// Auto-loads every dictionary file under ./dict (each exports an array of
// { en, sw } pairs) and builds the two lookup maps LanguageContext uses.
// Adding a new dict file is enough to register it — nothing else to wire up.
const req = require.context("./dict", false, /\.js$/);

export const enToSw = {};
export const swToEn = {};

req.keys().forEach((key) => {
  const mod = req(key);
  const pairs = mod.default || mod;
  if (!Array.isArray(pairs)) return;
  pairs.forEach(({ en, sw }) => {
    if (!en || !sw) return;
    if (enToSw[en] && enToSw[en] !== sw) {
      // eslint-disable-next-line no-console
      console.warn(`[i18n] duplicate English key with different Swahili values: "${en}"`);
    }
    enToSw[en] = sw;
    swToEn[sw] = en;
  });
});
